import React, { useCallback } from "react";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import { useTracker } from "@dpdgroupuk/react-event-tracker";

import ActionButtons from "../Buttons/ActionButtons";

const ActionsSnackbar = ({
  onConfirm,
  onClose,
  confirmActionId,
  cancelActionId,
  ...params
}) => {
  const tracker = useTracker();
  const clickConfirm = useCallback(() => {
    confirmActionId && tracker.logEvent(confirmActionId);
    onConfirm && onConfirm();
  }, [confirmActionId, onConfirm, tracker]);

  const clickClose = useCallback(() => {
    cancelActionId && tracker.logEvent(cancelActionId);
    onClose && onClose();
  }, [cancelActionId, onClose, tracker]);

  return (
    <SnackbarContent
      {...params}
      action={<ActionButtons onConfirm={clickConfirm} onClose={clickClose} />}
    />
  );
};

export default ActionsSnackbar;
